import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900" data-testid="auth-checking">
        <div className="text-slate-400 label-tech">{t("common.checkingSession")}</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
